module.exports = __webpack_public_path__ + "img/LK.0a19d1a9.png";